import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="mx-auto max-w-[1360px] px-6 py-20">
      <p className="text-xs tracking-[0.18em] text-brass uppercase">Erro 404</p>

      <h1 className="mt-4 font-display text-4xl">Esta página não existe.</h1>

      <Link
        to="/"
        className="mt-8 inline-block border border-ink px-5 py-3 text-sm transition-colors hover:bg-ink hover:text-bone"
      >
        Voltar ao início
      </Link>
    </section>
  );
}
